import type { Site } from '@/types/site';

interface WaterSupplyDetailTabProps {
  site: Site;
}

export default function WaterSupplyDetailTab({
  site,
}: Readonly<WaterSupplyDetailTabProps>) {
  return (
    <div className="space-y-6">
      <div className="bg-gray-50 rounded-xl p-6">
        <h4 className="text-lg font-semibold text-gray-900 mb-4">급수 정보</h4>
        {site.waterSupplyInfo ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* 급수 계획 */}
            {site.waterSupplyInfo.plan && (
              <div className="bg-white rounded-lg p-4 border">
                <h5 className="font-semibold text-gray-900 mb-3">급수 계획</h5>
                <div className="space-y-2 text-sm">
                  {site.waterSupplyInfo.plan.people && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">인구수:</span>
                      <span className="text-gray-900">
                        {site.waterSupplyInfo.plan.people.toLocaleString()}명
                      </span>
                    </div>
                  )}
                  {site.waterSupplyInfo.plan.family && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">가구수:</span>
                      <span className="text-gray-900">
                        {site.waterSupplyInfo.plan.family.toLocaleString()}가구
                      </span>
                    </div>
                  )}
                  {site.waterSupplyInfo.plan.waterSupplyPerPerson && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">1인당 급수량:</span>
                      <span className="text-gray-900">
                        {site.waterSupplyInfo.plan.waterSupplyPerPerson}L
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* 급수 현황 */}
            {site.waterSupplyInfo.current && (
              <div className="bg-white rounded-lg p-4 border">
                <h5 className="font-semibold text-gray-900 mb-3">급수 현황</h5>
                <div className="space-y-2 text-sm">
                  {site.waterSupplyInfo.current.people && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">현재 인구수:</span>
                      <span className="text-gray-900">
                        {site.waterSupplyInfo.current.people.toLocaleString()}명
                      </span>
                    </div>
                  )}
                  {site.waterSupplyInfo.current.family && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">현재 가구수:</span>
                      <span className="text-gray-900">
                        {site.waterSupplyInfo.current.family.toLocaleString()}
                        가구
                      </span>
                    </div>
                  )}
                  {site.waterSupplyInfo.current.waterSupplyPerPerson && (
                    <div className="flex justify-between">
                      <span className="text-gray-600">현재 1인당 급수량:</span>
                      <span className="text-gray-900">
                        {site.waterSupplyInfo.current.waterSupplyPerPerson}L
                      </span>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* 급수 제한 */}
            {site.waterSupplyInfo.supplyLimit && (
              <div className="bg-white rounded-lg p-4 border md:col-span-2">
                <h5 className="font-semibold text-gray-900 mb-2">
                  급수 제한사항
                </h5>
                <p className="text-sm text-gray-600">
                  {site.waterSupplyInfo.supplyLimit}
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className="text-center py-8">
            <i className="ri-drop-line text-4xl text-gray-400 mb-2"></i>
            <p className="text-gray-500">등록된 급수 정보가 없습니다.</p>
          </div>
        )}
      </div>
    </div>
  );
}
